//data reducers
export const SET_RESTAURANTS = "SET_RESTAURANTS";
export const SET_RESTAURANT = "SET_RESTAURANT";
export const LOADING_DATA = "LOADING_DATA";
export const ADD_CART_SUCCESS = "ADD_CART_SUCCESS";
export const ADD_CART_FAIL = "ADD_CART_FAIL";
export const SET_CART = "SET_CART";
export const DELETE_ITEM_CART = "DELETE_ITEM_CART";
export const SET_ORDERS = "SET_ORDERS";
export const EDIT_STATUS = "EDIT_STATUS";

//UI reducers
export const SET_ERRORS = "SET_ERRORS";
export const LOADING_UI = "LOADING_UI";
export const CLEAR_ERRORS = "CLEAR_ERRORS";
export const SERVER_ERROR = "SERVER_ERROR";
export const SIGNUP_SUCCESS = "SIGNUP_SUCCESS";
export const SET_ERROR = "SET_ERROR";
export const SET_ERRORS_SIGNUP_SELLER = "SET_ERRORS_SIGNUP_SELLER";
export const SET_ERROR_ITEM = "SET_ERROR_ITEM";

//user reducers
export const LOADING_USER = "LOADING_USER";
export const SET_USER = "SET_USER";
export const SET_AUTHENTICATED = "SET_AUTHENTICATED";
export const SET_UNAUTHENTICATED = "SET_UNAUTHENTICATED";
export const ADD_ITEM = "ADD_ITEM";
export const DELETE_ITEM = "DELETE_ITEM";
export const EDIT_ITEM = "EDIT_ITEM";
